import { useSelector } from 'react-redux'
import { Card, Row, Col, Progress, Flex, Divider, Skeleton } from 'antd'
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';

// Constant

// Components

// Handlers
import { REDUX } from '../../../../services/util'

// Styles
import styles from './style.module.css'


const UtilizationExtras = ({filteredData}) => {

    const vehicles = useSelector(REDUX.reduxStoreWrapper('vehicles.staticsByID'))
    const loading = useSelector(REDUX.reduxStoreWrapper('style.loading.vehicleReport'))

    // const totalUtilized = filteredData
    //     .reduce((acc, { utilisation_rate = 0 }) => acc + utilisation_rate, 0);

    // const totalNotUtilized = filteredData
    //     .reduce((acc, { utilisation_rate = 0 }) => acc + (100 - utilisation_rate), 0);
    
    // const total = (parseFloat(totalUtilized) + parseFloat(totalNotUtilized)).toFixed(1);
    
    // const utilisationRate = [
    //     { title: "Utilised", amount: (((totalUtilized / total) * 100) || 0).toFixed(1), strokeColor: '#ffa96a' },
    //     { title: "Not Utilised", amount: (((totalNotUtilized / total) * 100) || 0).toFixed(1), strokeColor: '#ede7ca' }
    // ];

    const totalUtilized = filteredData.reduce((sum, data) => sum + data.utilisation, 0) / filteredData.length
    const totalNotUtilized = 100 - totalUtilized
    
    const total = (parseFloat(totalUtilized) + parseFloat(totalNotUtilized)).toFixed(1);

    const percentageUtilized = (((totalUtilized / total) * 100) || 0).toFixed(1)
    const percentageNotUtilized = (((totalNotUtilized / total) * 100) || 0).toFixed(1)
    
    const utilisationRate = [
        { title: "Utilised", amount: percentageUtilized >= 100 ? 100 : percentageUtilized, strokeColor: '#ffa96a' },
        { title: "Not Utilised", amount: percentageNotUtilized < 0 ? 0 : percentageNotUtilized, strokeColor: '#ede7ca' }
    ];

    const mostUtilised = filteredData
    .sort((a, b) => b.utilisation - a.utilisation)
    .slice(0, 3);

    const leastUtilised = filteredData
    .sort((a, b) => a.utilisation - b.utilisation)
    .slice(0, 3);


    const progressUtilised = (utilised) => {
    return (
        <Flex vertical>
            {utilised.map((u, index) => (
            <div className={styles['container-bar']} key={u.vid || index}>
                <LocalShippingOutlinedIcon style={{ color: '#d8d8d8' }} />
                <span><b>{vehicles?.[u.vid]?.plate || '-'}</b></span>
                <Progress
                    percent={u.utilisation}
                    strokeColor="#F5A267"
                    format={(percent) => `${percent.toFixed(1)}%`}
                />
            </div>
            ))}
        </Flex>
    )};



    return (
        <div className={styles['container']}>
            <Row gutter={15}>
                <Col span={8}>
                    <Card title={'Vehicle Utilization Rate'}>

                        { loading ? 
                            <Skeleton active={loading} paragraph={{ rows: 1 }} /> :
                            <div className={styles['container-doughnut']}>
                                <Progress
                                    percent={total}
                                    strokeColor="#ede7ca"
                                    success={{
                                        percent: ((totalUtilized / total) * 100),
                                        strokeColor: "#ffa96a",
                                    }}
                                    showInfo={false}
                                    type="circle"
                                    trailColor={"#e0e0e0"}
                                />
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '10px'}}>
                                {utilisationRate.map((data) => (
                                        <Row key={data.id} className='spending-row'>
                                        <Divider
                                            type="vertical"
                                            className='divider'
                                            style={{ borderColor: data.strokeColor }}
                                        />
                                        <div>
                                            <b>{data.title}</b>
                                            <div>{data.amount} %</div>
                                        </div>
                                        </Row>
                                    ))}
                                </div>
                            </div>
                        }
                    </Card>
                </Col>
                <Col span={8}>
                    <Card title={'Least Utilized Vehicle'} >
                        {loading ? <Skeleton active={loading} paragraph={{ rows: 1 }} /> : progressUtilised(leastUtilised)}
                    </Card>
                </Col>
                <Col span={8}>
                    <Card title={'Most Utilized Vehicle'} >
                        {loading ? <Skeleton active={loading} paragraph={{ rows: 1 }} /> : progressUtilised(mostUtilised)}
                    </Card>
                </Col>
            </Row>
        </div>
    )
}

export default UtilizationExtras